"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessages = void 0;
const react_1 = require("react");
const navActions_1 = require("../context/navActions");
const navContext_1 = require("../context/navContext");
const useMessages = () => {
    const { state, dispatch } = (0, react_1.useContext)(navContext_1.NavContext);
    const setMessages = (messages) => {
        dispatch({ type: navActions_1.ActionTypes.SET_MESSAGES, value: messages });
    };
    return (0, react_1.useMemo)(() => {
        return {
            messages: state.messages,
            setMessages,
        };
    }, [state.messages]);
};
exports.useMessages = useMessages;
//# sourceMappingURL=messages.hooks.js.map